import color, { hue } from "./helpers.js";
import {} from "d3";
import { okhsl } from "../color/okhsl.js";
import lineInterpolationFactory from './interpolate-hsl-as-lab.js';
const interpolatorFactory = (hueInterpolator) => {
    return (a, b) => {
        const _a = okhsl(a);
        const _b = okhsl(b);
        const h = hueInterpolator(_a.h, _b.h);
        const s = color(_a.s, _b.s);
        const l = color(_a.l, _b.l);
        const opacity = color(_a.opacity, _b.opacity);
        return (t) => {
            _a.h = h(t);
            _a.s = s(t);
            _a.l = l(t);
            _a.opacity = opacity(t);
            return _a.toString();
        };
    };
};
export const interpolateOkhsl = interpolatorFactory(hue);
export const interpolateOkhslLong = interpolatorFactory(color);
export const interpolateOkhslLine = lineInterpolationFactory(okhsl);
